import { Box, Button, Chip, Typography, useTheme } from '@mui/material';
import React from 'react';

import { getTextColor, SKILL_LEVELS } from '../data/skillLevels';

interface LevelSelectorProps {
    level: 1 | 2 | 3 | 4;
    onChange: (level: 1 | 2 | 3 | 4) => void;
    disabled?: boolean;
}

const SKILL_LEVEL_DESCRIPTIONS = [
    {
        level: 1 as const,
        description: 'Grundlegendes Wissen und Fähigkeiten',
    },
    {
        level: 2 as const,
        description: 'Solides Verständnis, Umfangreiche Kenntnisse in einem geschlossenen Kontext',
    },
    {
        level: 3 as const,
        description: 'Breites und tiefes Verständnis, Umfangreiche Kenntnisse in mehreren Kontexten',
    },
    {
        level: 4 as const,
        description: 'Exzellentes Wissen und Fähigkeiten, Umfangreiche Kenntnisse in diversen Kontexten',
    },
];

export default function LevelSelectorButtons({ level, onChange, disabled = false }: LevelSelectorProps) {
    const theme = useTheme();
    const selectedLevel = SKILL_LEVELS.find((l) => l.level === level);
    const selectedDescription = SKILL_LEVEL_DESCRIPTIONS.find((l) => l.level === level);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* Tab Buttons for Levels */}
            <Box sx={{ display: 'flex', gap: 0.5 }}>
                {SKILL_LEVELS.map((skillLevel) => {
                    const isSelected = level === skillLevel.level;

                    return (
                        <Button
                            key={skillLevel.level}
                            variant="contained"
                            size="small"
                            disabled={disabled}
                            onClick={() => onChange(skillLevel.level)}
                            sx={{
                                minWidth: 40,
                                height: 32,
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                borderRadius: 1,
                                border: `2px solid ${isSelected ? theme.palette.primary.main : 'transparent'}`,
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark,
                                },
                            }}
                        >
                            {skillLevel.level}
                        </Button>
                    );
                })}
            </Box>

            {selectedLevel && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                        label={`${selectedLevel.name} (${selectedLevel.level})`}
                        size="small"
                        sx={{
                            backgroundColor: selectedLevel.color,
                            color: getTextColor(selectedLevel.level),
                            fontWeight: 500,
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {selectedDescription?.description}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
